var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrow = function SvgIconArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.37165 4.58706C5.17303 4.80775 4.82697 4.80775 4.62835 4.58706L1.25104 0.834483C0.96145 0.512722 1.1898 2.27173e-07 1.62268 2.65017e-07L8.37732 8.55526e-07C8.81021 8.9337e-07 9.03855 0.512722 8.74897 0.834483L5.37165 4.58706Z",
    fill: "#2F2F4B"
  })));
};
export default SvgIconArrow;